import { Form as FormikForm, Formik, useFormikContext } from "formik";
import React from "react";
import * as Yup from "yup";
import {
  ICohortWorkingForm,
  initialCohortWorkingForm,
} from "../../routes/registries/models/Cohort";
import { FormInputControl, FormInputControlProps } from "../forms";

interface IProps extends FormInputControlProps {
  onFormChange: (values: ICohortWorkingForm) => void;
}

const FormikObserver = (props: Pick<IProps, "onFormChange">) => {
  const formik = useFormikContext<ICohortWorkingForm>();

  React.useEffect(() => {
    if (formik.isValid) {
      props.onFormChange(formik.values);
    }
  }, [props, formik]);

  return null;
};

export const CohortInlineForm = (props: IProps) => {
  const { onFormChange, value, ...rest } = props;

  const [workingFormValues] = React.useState<ICohortWorkingForm>(
    value ? { title: `${value}` } : initialCohortWorkingForm
  );

  const CohortFormsSchema = Yup.object().shape({
    title: Yup.string().max(28, "Please keep it shorter"),
  });

  return (
    <Formik
      initialValues={workingFormValues}
      validationSchema={CohortFormsSchema}
      onSubmit={() => {}}
      enableReinitialize={true}
    >
      {(props) => {
        return (
          <FormikForm>
            <FormikObserver onFormChange={onFormChange} />
            <FormInputControl {...rest} />
          </FormikForm>
        );
      }}
    </Formik>
  );
};
